import SignInSide from './sign-in-side/SignInSide'
import { useNavigate} from "react-router";
import React, { Suspense } from 'react';
import './App.css';
import Box from '@mui/material/Box';
import { Provider } from 'react-redux'
import {store} from './store'
import {useEffect,useState,useRef } from 'react'
//import {CustomSubmitRenderer} from './provider/CustomerButtonRenderer'
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import {setValidFunctions} from './redux/appState';
import { Stack } from '@mui/material';
import {useChangeAliasUserMutation, useLogoutMutation,useGetLoginStatusQuery,authApi} from './redux/authApi'
import {useLoadUserQuery,useCheckPermissionsQuery,
		useGetAccountQuery,
		useGetOrgInfoQuery,
		databaseViewApi} from './redux/databaseView';
import {isAdministrator,isUserManager,isFormManager,isWorkflowEditor} from './Permission'
import {SubMenu} from './SubMenu'
import {useDispatch} from 'react-redux';
import MenuItem from '@mui/material/MenuItem';
import '@bpmn-io/form-js/dist/assets/form-js.css';
import '@bpmn-io/form-js/dist/assets/form-js-editor.css';
import '@bpmn-io/form-js/dist/assets/form-js-playground.css';
import { createBrowserRouter,useParams,Outlet } from "react-router";
import { RouterProvider } from "react-router/dom";
//import { BrowserRouter as Router, Route, Routes, useParams } from "react-router/dom";
import { useLocation } from 'react-router'
import SignUp from './sign-up/SignUp';
import { redirect } from "react-router";
import {ProcessExecute} from './ProcessExecute'
import ResetPassword from './ResetPassword'
import {Dashboard} from './Dashboard'
import {UserManagement} from './UserManagement'
import {SiteSettings} from './SiteSettings'
import Welcome from './welcome';
import {Snackbar,Alert,Menu} from "@mui/material";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Account from './Accounts';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const BPMNModeler = React.lazy(()=> import('./BPMNModeler.js'));
const FormViewer = React.lazy(()=> import('./FormViewer.js'));


function LazyBPMNModeler() {
  return (
    <div style={{width:'100%'}}>
      <Suspense fallback={<div>Loading...</div>}>
        <BPMNModeler />
      </Suspense>
    </div>
  );
}


function LazyFormViewer() {
  return (
    <div style={{width:'100%'}}>
      <Suspense fallback={<div>Loading...</div>}>
        <FormViewer />
      </Suspense>
    </div>
  );
}





export function BasicMenu()
	{
	const navigate=useNavigate();
	const location=useLocation();
	const userList=useLoadUserQuery();
	const [logout]=useLogoutMutation();

	const [val,setValue]=useState("");

	const loading=useGetLoginStatusQuery();
	const permissions=useCheckPermissionsQuery();

	const dispatch=useDispatch();
	const {data:orgData}=useGetOrgInfoQuery()

	const [changeAliasUser]=useChangeAliasUserMutation();
	const account=useGetAccountQuery();
	const [accountAnchor,setAccountAnchor]=useState(null);
	const displayName=
		account?.data?.data?.displayName||
		account?.data?.displayName||
		"Account";
	useEffect(()=>
		{
		dispatch(setValidFunctions({}));
		},[location.pathname,dispatch]);
	
	useEffect(()=>
		{
		if (loading.isSuccess)
			setValue(loading.data.data.id);
		},[loading.isSuccess,loading.data]);

	async function handleLogout()
		{
		setAccountAnchor(null);

		try
			{
			await logout().unwrap();
			localStorage.removeItem('authToken');
			console.log("remove");
			localStorage.removeItem('authToken');
			dispatch(databaseViewApi.util.resetApiState());
			navigate("/",{replace:true});
			}
		catch (error)
			{
			console.error("Logout failed",error);
			}
		}
//	if (!permissions.isSuccess)
//		return null;


	const roles=permissions?.data?.data?.roles??{};
	console.log(roles,permissions);

	const handleChange=async (event:SelectChangeEvent)=>
		{
		var aliasID=event.target.value;
		var data=await changeAliasUser({aliasID}).unwrap();		
		console.log(data);
		setValue(data?.data?.id);
		setAuthToken(JSON.stringify(data?.data));
		dispatch(databaseViewApi.util.resetApiState());

		navigate('/',{replace:true});
		};


	const success=userList.isSuccess&&userList.data.success;
	const options=success?userList.data.data:[];


	const navigationItems=[
		{
		name:"Dashboard",
		path:"/",
		show:true
		},
		{
		name:"Processes",
		path:"/workflow",
		show:isWorkflowEditor(roles)
		},
		{
		name:"Forms",
		path:"/form",
		show:isFormManager(roles)
		},
		{
		name:"Users",
		path:"/usermanager",
		show:isUserManager(roles)
		},
		{
		name:"Settings",
		path:"/settings",
		show:isAdministrator(roles)
		},
		];


	function isActive(path)
		{
		if (path==="/")
			return location.pathname==="/";

		return location.pathname.startsWith(path);
		}
	
	function amAdmin()
		{
		var token=localStorage.getItem("authToken");
		if (!token)
			return false;
		token=JSON.parse(token);
		if (!token?.admin)
			return false;
		return true;
		}
	var admin=amAdmin()&&options.length;
	console.log("admin" ,admin);
	return (
		<AppBar
			position="static"
			color="default"
			elevation={0}
			sx={{
				backgroundColor:'white',
				color:'text.primary',
				flexShrink:0,
				paddingBottom:2,
				}}
		>
			<Toolbar
				variant="dense"
				sx={{
					minHeight:'48px !important',
					height:48,
					gap:0.5,
					px:2
					}}
			>

				<Typography
					variant="subtitle1"
					sx={{
						fontWeight:700,
						mr:3,
						whiteSpace:'nowrap'
						}}
				>
					{orgData?.data?.orgName??"Document as You Do"}
				</Typography>


				{navigationItems
					.filter(item=>item.show)
					.map(item=>
						<Button
							key={item.name}
							onClick={()=>navigate(item.path)}
							color="inherit"
							sx={{
//								height:48,
								px:0,
								mx:1.5,
								borderRadius:0,
								py:1,
								textTransform:'none',
								fontWeight:isActive(item.path)?600:400,
								position:'relative',

								'&::after':isActive(item.path)
									?{
										content:'""',
										position:'absolute',
										bottom:0,
										left:'0%',
										width:'100%',
										height:2,
										borderRadius:'3px 3px 0 0',
										backgroundColor:'primary.main'
										}
									:null
								}}
						>
							{item.name}
						</Button>
						)
				}


				<Box sx={{flex:1}} />


				{/* Keep editor/file actions available for now */}



				{admin ?(
					<FormControl
						variant="outlined"
						sx={{
							ml:2,
							minWidth:220
							}}
					>
						<Stack
							direction="row"
							spacing={1}
							alignItems="center"
						>

							<FormLabel
								htmlFor="supervisor"
								sx={{
									whiteSpace:'nowrap',
									fontSize:'0.8rem'
									}}
							>
								Impersonate
							</FormLabel>


							<Select
								value={val}
								onChange={handleChange}
								displayEmpty
								MenuProps={{
									disableScrollLock:true
									}}
								renderValue={(selected)=>
									{
									if (selected==="")
										return <em>Default User</em>;

									const option=
										options.find(
											o=>o.id===selected
											);

									return option
										?option.name
										:selected;
									}}
								sx={{
									height:32,

									"& .MuiSelect-select":
										{
										padding:"4px 28px 4px 8px",
										minHeight:"unset",
										lineHeight:1.2
										},

									"& .MuiSelect-icon":
										{
										right:4,
										transition:"none"
										}
									}}
							>

								<MenuItem value="">
									<em>None</em>
								</MenuItem>

								{options.map(x=>
									<MenuItem
										key={x.id}
										value={x.id}
									>
										{x.name}
									</MenuItem>
									)
								}

							</Select>
						
						</Stack>
					</FormControl>):null
				}
				<Button
					color="inherit"
					onClick={(event)=>setAccountAnchor(event.currentTarget)}
					startIcon={<AccountCircleOutlinedIcon/>}
					endIcon={<KeyboardArrowDownIcon/>}
					sx={{
						ml:2,
						textTransform:'none',
						fontWeight:500,
						whiteSpace:'nowrap'
						}}
				>
					{displayName}
				</Button>
				<Menu
					anchorEl={accountAnchor}
					open={Boolean(accountAnchor)}
					onClose={()=>setAccountAnchor(null)}
				>
					<MenuItem
						onClick={()=>
							{
							setAccountAnchor(null);
							navigate("/account");
							}}
					>
						Account
					</MenuItem>

					<MenuItem
						onClick={()=>
							{
							setAccountAnchor(null);
							handleLogout();
							}}
					>
						Logout
					</MenuItem>
				</Menu>

			</Toolbar>
			<SubMenu
					filter
					flat
					name="Actions"
					menuList={[
						"New",
						"Open",
						"Save",
						"Revert",
						"Publish",
						"DataXChange",
						"Delete",
						]}
				/>

		</AppBar>
		);
	}

async function loader() 
	{
	var id=await isAuthenticated();
	if (id)
		{
		console.log("claims authenticated",id);
		return redirect("/");
		}
      // return data from here
	console.log("execute loader");
    }
	
async function isAuthenticated () 
	{
      // Replace with your actual authentication logic (e.g., checking a token in localStorage)
	  var authToken=await localStorage.getItem('authToken');
      return (authToken!=null);
    };
/*
const writeAssigned=0x10;
const writeOwnTeam=0x20;
const writeAccessAll=0x40;
const writeAccessAllUnrestricted=0x80;
*/
const readSecure=1;
const writeSecure=2;

function ensureFourDigits(num) {
  return String(num).padStart(4, '0');
}

export async function getAccess(params)
	{
	var res=store.dispatch(databaseViewApi.endpoints.checkAccess.initiate(params));
	var login=await store.dispatch(authApi.endpoints.getLoginStatus.initiate(params));

	res=await res;

	if (login.data.failure||res.data.failure)
		return null;

	if (!res.data.data?.length)
		return null;

	var access=0;
	var userID=login.data.data.id;

	res.data.data.forEach((x)=>
		{
		var instAccess=x.access;

		if (x.teamName===null)
			access=(readSecure|writeSecure);
		else
			{
			if (instAccess&0x600)
				access|=3;

			if (instAccess&0xe0)
				access|=(writeSecure|readSecure);

			if (instAccess&0x10&&x.staffName===userID)
				access|=(writeSecure|readSecure);

			if (instAccess&0xe)
				access|=readSecure;
			else if (instAccess&0x1&&x.staffName===userID)
				access|=readSecure;
			}
		});

	const project=res.data.data[0].prefix+ensureFourDigits(res.data.data[0].typeID);

	return {project,access};
	}
	
export async function checkAccess({params})
	{
	var result=await getAccess(params);

	if (!result)
		return redirect("/");

	return result;
	}	


const router = createBrowserRouter([
	{
	element: <Layout />,
	children: [
				{path: "/",Component: Dashboard,},
				{path: "/form",Component: LazyFormViewer,},
				{path: "/workflow",Component: LazyBPMNModeler,},
				{path: "/signin",Component: Dashboard,loader},
				{path: "/signup",Component: Dashboard,loader},
				{path: "/ChangePass",Component: ResetPassword},
				{path: "/usermanager",Component: UserManagement,},
				{path: "/settings",Component: SiteSettings,},
				{path: "/account",Component: Account,},
				{path: "/fileViewer/:fileID/:name?",Component: FileViewer,},
				{path: "/data/:instance/:state/",Component: ProcessExecute,loader:checkAccess},
				{path: "/data/:instance/:state/:version",Component: ProcessExecute,loader:checkAccess}
				]
	}]);

async function getFile(fileId)
	{
	var token=localStorage.getItem("authToken");
	if (token)
		token=JSON.parse(token);
	
	const res=await fetch(`https://docsasudo.com/download.php?file=${fileId}`,{
		method:'GET',
		credentials:'include',
		headers:
		{
		Authorization:`Bearer ${token.jwt}`
		}
		});

	if (!res.ok)
		{
		const text=await res.text();

		if (res.status===401)
			throw new Error("You are not logged in.");

		if (res.status===403)
			throw new Error("You do not have access to this file.");

		if (res.status===404)
			throw new Error("The file could not be found.");

		throw new Error(text||`Unable to retrieve file (${res.status}).`);
		}

	return res;
	}

	
	
function FileViewer()
	{
	const [url,setUrl]=useState(null);
	const [error,setError]=useState(null);
	const {fileID,name}=useParams();

	useEffect(()=>
		{
		let objectUrl=null;
		let closeTimer=null;

		async function load()
			{
			try
				{
				const res=await getFile(fileID);
				const blob=await res.blob();

				if (!blob.size)
					throw new Error("The file is empty.");

				objectUrl=window.URL.createObjectURL(blob);
				setUrl(objectUrl);
				}
			catch (err)
				{
				console.error(err);
				setError("Unable to open this file.");

				closeTimer=setTimeout(()=>
					{
					window.close();
					},2500);
				}
			}

		load();

		return ()=>
			{
			if (objectUrl)
				window.URL.revokeObjectURL(objectUrl);

			if (closeTimer)
				clearTimeout(closeTimer);
			};
		},[fileID]);

	function displayFailed()
		{
		setUrl(null);
		setError("This file cannot be displayed in the browser.");

		setTimeout(()=>
			{
			window.close();
			},2500);
		}

	if (error)
		return (
			<div style={{
				height:"100vh",
				width:'100%',
				display:"flex",
				alignItems:"center",
				justifyContent:"center",
				flexDirection:"column",
				fontFamily:"sans-serif"
				}}>
				<h2>{error}</h2>
				<div>This window will close automatically.</div>
			</div>
			);

	if (!url)
		return (
			<div style={{
				height:"100vh",
				width:'100%',
				display:"flex",
				alignItems:"center",
				justifyContent:"center",
				flexDirection:"column",
				fontFamily:"sans-serif"
				}}>
				Loading...
			</div>
			);

	return (
		<iframe
			src={url}
			title={name||"File"}
			onError={displayFailed}
			style={{
				width:"100%",
				height:"100vh",
				border:0
				}}
		/>
		);
	}

function setAuthToken(token)
	{
	var originalToken=localStorage.getItem('authToken');
	if (originalToken!==token)
		{
		localStorage.setItem('authToken',token);
		//probably want to reset the databaseView api to indicate get everything again
		}
	}
	
function Layout()
	{
	const navigate=useNavigate();
	const loading=useGetLoginStatusQuery();
	const location = useLocation();
	const reloadTimer=useRef(0);
	const onLogin=() =>
		{
		console.log("on signin");
		localStorage.removeItem('authToken');
		navigate('/signin');
		};
	const [accessDenied,setAccessDenied]=useState(false);
	useEffect(()=>
		{
		var params=new URLSearchParams(location.search);

		if (params.get("accessDenied"))
			{
			setAccessDenied("You do not have access to this process or state");
			params.delete("accessDenied");

			navigate({
				pathname:location.pathname,
				search:params.toString()
				},{
				replace:true
				});
			}
		else if (params.get("alternateTeam"))
			{
			setAccessDenied("Another team has been assigned to set up this processes information");
			params.delete("alternateTeam");

			navigate({
				pathname:location.pathname,
				search:params.toString()
				},{
				replace:true
				});			
			}
		},[location,navigate]);
	const onRegister=() =>
		{
		localStorage.removeItem('authToken');
		console.log("on signup");
		navigate('/signup');
		};
//	const [search,setSearch]=useSearchParams();
	useEffect(()=>{
		if (loading.isSuccess&&!loading.isFetching&&!loading.isLoading)
			{
			setAuthToken(JSON.stringify(loading.data.data));
			}
		},[loading,loading.isSuccess]);
	 if (loading.isSuccess)
		reloadTimer.current=2;
	 else if (reloadTimer.current===2)
		reloadTimer.current=0;
	 if (loading.isFetching)
		{
		function reload()
			{
			if (reloadTimer.current)
				return;
			reloadTimer.current=1;
			setTimeout(()=>{
				if (loading.current===1)
					{
					loading.refetch();
					reloadTimer.current=0;
					reload();
					}
				},1000);
			}
		reload();
		}
//	console.log('reloading',loading,loading.isSuccess);
	if (!loading.isSuccess)
		return (<div></div>);
//	console.log(loading.data,location.pathname);
	if (!loading.data.data.id)
		{
		if (location.pathname==="/signup")
			return <SignUp/>;

		if (location.pathname==="/ChangePass")
			return <ResetPassword/>;

		if (location.pathname==="/signin")
			return <SignInSide/>;

		return <Welcome onLogin={onLogin} onRegister={onRegister}/>;
		}//	console.log(permissions);
	//console.log(loading,location);
	return (
		<div
			style={{
				height: '100%',
				display: 'flex',
				flexDirection: 'column',
				minHeight: 0,
				overflow: 'hidden'
			}}
		>
				<BasicMenu />

			<div
				style={{
					flex: 1,
					display: 'flex',
					minHeight: 0,
					overflow: 'hidden'
				}}
			>
			<Snackbar
				open={!!accessDenied}
				autoHideDuration={5000}
				onClose={()=>setAccessDenied(false)}
				anchorOrigin={{vertical:"top",horizontal:"center"}}
			>
				<Alert
					severity="warning"
					variant="filled"
					onClose={()=>setAccessDenied(false)}
				>
				{accessDenied}
				</Alert>
			</Snackbar>

				<Outlet/>
			</div>
		</div>
	)
	}
function App() {
  const debugging = process.env.NODE_ENV === "development";
  useEffect(()=>{
//	  console.log("debugging mode",debugging);
	  },[debugging]);
  return (
    <div className="App" style={{height:'100%',display:'flex',flexDirection:'column'}}>
	<Provider store={store}>
		<RouterProvider router={router} />
{/*	  <BasicSpeedDial style={{position: 'absolute',right:-200,bottom:-200}} /> */}
	</Provider>
    </div>
  );
}






	
export default App;
//       pageSizeOptions={[5, 10]}
 //       initialState={{ pagination: { paginationModel } }}
